import { useQuery } from 'react-query';

import { useRequest, QueryFunction } from '@frontend/api';

type QuoteItemId = number;
type FileUuid = string;

type TableExtraction = {
  uuid: string;
  filename: string;
  page: number;
};

export type QuoteItemMatchesData = {
  bomTablesFoundIn: Record<QuoteItemId, TableExtraction[]>;
  fileAssignments: Record<QuoteItemId, FileUuid[]>;
};

export type UseQuoteItemMatchesParams = {
  quoteId: number | string | null;
};

export const getUseGetQuoteItemMatchesKey = (
  params: UseQuoteItemMatchesParams,
) => ['quoteFileToQuoteItemMatches', params.quoteId] as const;

export const useGetQuoteItemSuggestions: QueryFunction<
  QuoteItemMatchesData,
  [UseQuoteItemMatchesParams],
  ReturnType<typeof getUseGetQuoteItemMatchesKey>
> = (params, { requestOptions, queryOptions = {} } = {}) => {
  const request = useRequest(requestOptions);
  const queryKey = getUseGetQuoteItemMatchesKey(params);
  const { quoteId } = params;

  if (quoteId == null) {
    queryOptions.enabled = false;
  }

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) => {
      return request(`/quotes/${params.quoteId}/line_item_suggestions`, {
        init: {
          signal,
        },
      });
    },
  });
};
